import { Controller } from "stimulus";
import * as SDCCore from "@scandit/web-datacapture-core";
import * as SDCBarcode from "@scandit/web-datacapture-barcode";

export default class extends Controller {
  static targets = ["input"];
  static values = {
    env: String,
  };

  async connect() {
    const scannerId = document.getElementById("scandit-barcode-picker");
    const object = this;
    if (scannerId) {
      //await barcodeCapture.setEnabled(true);
      $("#scanditModal").on("shown.bs.modal", async function (event) {
        object.enableScanner(event);
      });
      $("#scanditModal").on("hidden.bs.modal", async function (event) {
        object.removeScandit(event);
      });
    }
  }

  disconnect() {
    //this.removeScandit();
    // document.removeEventListener("turbo:frame-render", this.enableScannerHandler);
    // document.removeEventListener("turbo:load", this.removeScanditHandler);
  }

  async initializeScandit() {
    const scannerId = document.getElementById("scandit-barcode-picker");
    await SDCCore.configure({
      licenseKey:
        "AhSWEC7hCGcrJKuGrPB9FfwknLyHQEfZzTP9g607vahyUTLnN2k9cZ1CY+teOwXypkvdymoaYP/NbFewJHLTVZJynpXqdHLQO0QthaYCRN+aJPo6r0PPDTMQ4vrqcOgLqwVJXjNgr7wAYlngT2/4sMdG96Dtdchu/Q9S5iFT49g5fP8tC3tW+Z5Qd+GQcchWXFRuSjdS/gyoQPJse0WCTuBVQeeSXpFDEmSrb4teWeG3TV1Bo3KKPrVJbzToQJMrLFH+15xEJGILaFDullShT7dK+K+WcY6HNnwss/kUxw/MI29sZHCtJv9PlLD+QEGkMSLwLsUTk1J4Rw5ZsHWPo5dlVjDsSK3sg0ITrYhcUxkTfjBcbWv2Ead6zJHHXs2czR3eeXoqGeMjVbrcWE2LpOlgQyl8bTAJTVaUGfwgdCfYVty+0HgngKEXKnmYDFESc2gcnIVKmTjrYY5ueCL1jkcoSRMGYhs0lFJJhK1uzG6eCskmdl+xswFSK7eOKJxtaE6L8ONyTgrrDn3kjA/RA6E7drHaTA+RRFiV8AAZexTnOW/lwba7kEYJRcRbQmAIdORcdfCifwrJCpjThWlEdKWRKCrRW0NLi1NkMdrMtKE/ZA+Og8Nnyd+LNLkVJPdGXhXQ0PZvWeyfCsPrV4Q4couFA9sLpW6oxk+e/bTnJyqNykPLKIFTvxgwVS1MF9sqnLBMj87SaljoX8hXHv0wsojoykYi7rrGU0ixBgb/nUrwGoAVEvditV8Hx9nCa4wdeYAOUqbQD3A3JNYx8B9ilho1ChciWrqeuRzKh4ex2R4bdMvC3buVOKMXEm9oFXYC0yq/5mipVf+L2oUUdhkU24pD4X8pdBZUQ5zJvIbqHQyuP1EE+choIG+v6Nm6D4CD1VkrtlFZPkqmf5Yi1HmhcYGKH91GSDNexwX0N+vmyia+1PotpVQTkCLOrms5B3tvZSJsav/u6wPAJ20XwpNYvVScbsWMgPv4jKINHgKf0f9zAQT4DdrDZ2HJW06FvW2+4MQH+2GCcyskEqj1mxJpnJgL2EDjCXTObRR4j4Aq++8Md44iBFNVZUn7uurMv+Pb+aLegMtFLE0w/AABsKzvJW/QWG2lcakSFFrz/VJIbkztgEfjoovoqQuPfCZ0aRnJYoTID+vz4nhJ5vb4XqY+qXPj1yU1avMWrTNYP83opMyNJhJdwRS27MtLriLla+RsM0I=",
      libraryLocation:
        "https://cdn.jsdelivr.net/npm/@scandit/web-datacapture-barcode@7.2.1/sdc-lib/",
      moduleLoaders: [SDCBarcode.barcodeCaptureLoader()],
    });
    this.view = new SDCCore.DataCaptureView();
    this.camera = SDCCore.Camera.default;
    this.context = await SDCCore.DataCaptureContext.create();
    const cameraSettings = SDCBarcode.BarcodeCapture.recommendedCameraSettings;
    await this.camera.applySettings(cameraSettings);
    await this.context.setFrameSource(this.camera);
    await this.context.frameSource.switchToDesiredState(
      SDCCore.FrameSourceState.Off
    );
    const settings = new SDCBarcode.BarcodeCaptureSettings();
    settings.enableSymbologies([
      SDCBarcode.Symbology.EAN8,
      SDCBarcode.Symbology.UPCE,
      SDCBarcode.Symbology.EAN13UPCA,
    ]);
    this.setBarcodeCaptureListener();
    this.barcodeCapture = await SDCBarcode.BarcodeCapture.forContext(
      this.context,
      settings
    );
    this.barcodeCapture.setEnabled(false);
  }

  setBarcodeCaptureListener() {
    this.listener = {
      didScan: (barcodeCapture, session) => {
        const barcode = session.newlyRecognizedBarcode;
        if (!barcode) {
          return;
        }
        const value = barcode.data;

        const input = document.querySelector("#product_ean");
        if (input && (input.value === null || input.value === "")) {
          input.value = value;
          $("#scanditModal").modal("hide");
          this.submitForm(input);
        }
      },
    };
  }

  // Submit turbo form while disabling instances related to the scandit scan
  async submitForm(input) {
    this.disableScanditVideoInstances();
    input.form.requestSubmit();
  }

  // Enable Scanner for Scandit
  async enableScanner(event) {
    if (!this.barcodeCapture) {
      await this.initializeScandit();
    }
    const scannerId = document.getElementById("scandit-barcode-picker");
    if (this.barcodeCapture && scannerId && !this.barcodeCapture.isEnabled()) {
      await this.view.setContext(this.context);
      this.barcodeCapture.addListener(this.listener);
      this.view.connectToElement(scannerId);
      if (this.context) {
        await this.context.frameSource.switchToDesiredState(
          SDCCore.FrameSourceState.On
        );
      }
      await this.barcodeCapture.setEnabled(true);
    } else if (
      this.barcodeCapture &&
      !scannerId &&
      this.barcodeCapture.isEnabled()
    ) {
      this.removeScandit();
    }
  }

  // Remove scandit scan
  removeScandit() {
    if (this.barcodeCapture) {
      this.disableScanditVideoInstances();
    }
  }

  // Disable instances related to the scandit scan
  async disableScanditVideoInstances() {
    if (this.camera)
      await this.camera.switchToDesiredState(SDCCore.FrameSourceState.Off);

    if (this.barcodeCapture) await this.barcodeCapture.setEnabled(false);

    if (this.view)
      this.view.detachFromElement(
        document.getElementById("scandit-barcode-picker")
      );
  }
}
